export var MenuColumnType;
(function (MenuColumnType) {
    MenuColumnType["Alternative"] = "alternative";
    MenuColumnType["Regular"] = "regular";
})(MenuColumnType || (MenuColumnType = {}));
export var MenuCtaType;
(function (MenuCtaType) {
    MenuCtaType["Button"] = "button";
    MenuCtaType["Phone"] = "phone";
    MenuCtaType["SearchField"] = "searchField";
})(MenuCtaType || (MenuCtaType = {}));
//# sourceMappingURL=menu.js.map